﻿import type { AddTabToWorkspaceOptions } from 'epic/workspace/common/tabs/tabsEpics';
import { openTabInWorkspaceEpic } from 'epic/workspace/common/tabs/tabsEpics';
import type { SecondaryMarketLiveReloadRequestedByOrderId } from 'state/secondaryMarket/live/live.actions';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import type { EpicWithThunk } from 'state/state.common';
import type { WorkspacePersistedTabsApplied } from 'state/workspaces/workspace.actions';

export function secondaryWorkspaceReloadLiveByOrderIdEpic(): EpicWithThunk {
  const opt: AddTabToWorkspaceOptions<SecondaryMarketLiveReloadRequestedByOrderId, WorkspacePersistedTabsApplied> = {
    workspaceReadyTriggers: ['WORKSPACE_PERSISTED_TABS_APPLIED'],
    targetWorkspace: 'secondaryMarketQuotes',
    triggers: ['SECONDARY_MARKET_LIVE_RELOAD_REQUESTED_BY_ORDER_ID'],
    navigateRoute: { path: '/secondary-market-quotes-workspace' },
    onReady: ({ orderId }) => {
      return liveThunks.tabCreatedByOderIdThunk(orderId);
    },
  };
  return openTabInWorkspaceEpic(opt);
}
